import { createContext } from 'react';
import { FormInstance } from 'antd/lib/form';

export interface ISearchFormContext {
  form: FormInstance | null;
  dataFormats: any;
}

export default createContext<ISearchFormContext>({
  form: null,
  dataFormats: {},
});
